import type { ReactNode } from 'react';
import { Button } from '@ics-portal/guardian';
import type {
    ResolvedAction,
    ToolbarItem,
} from '../../application/actions/use-actions';

export interface ToolbarProps {
    actions: ToolbarItem[];
    slot?: ReactNode;
    search?: ReactNode;
    columns?: ReactNode;
    status?: ReactNode;
}

export function TableToolbar(props: ToolbarProps): JSX.Element | null {
    const { actions, slot, search, columns, status } = props;
    if (actions.length === 0 && !slot && !search && !columns && !status)
        return null;

    return (
        <div className="ics-table__toolbar">
            <div className="ics-table__toolbar-actions">
                {actions.map((item) => (
                    <Button
                        key={item.action.id}
                        severity={
                            item.action.variant === 'primary'
                                ? undefined
                                : 'secondary'
                        }
                        icon={item.action.icon}
                        label={item.label}
                        disabled={item.disabled}
                        title={item.tooltip}
                        onClick={item.run}
                    />
                ))}
            </div>
            {slot ? (
                <div className="ics-table__toolbar-slot">{slot}</div>
            ) : null}
            {search}
            {columns}
            {status}
        </div>
    );
}

export interface RowMenuProps<T> {
    items: ResolvedAction<T>[];
    label: string;
}

export function RowMenu<T>(props: RowMenuProps<T>): JSX.Element | null {
    const { items, label } = props;
    if (items.length === 0) return null;

    return (
        <div className="ics-table__row-menu" role="menu" aria-label={label}>
            {items.map((item) => (
                <button
                    key={item.action.id}
                    type="button"
                    role="menuitem"
                    disabled={item.disabled}
                    title={item.tooltip}
                    onClick={item.run}
                >
                    {item.action.icon ? (
                        <span aria-hidden="true">{item.action.icon}</span>
                    ) : null}
                    {item.label}
                </button>
            ))}
        </div>
    );
}
